import axios from 'axios';
import Alert from 'components/Alert';

const axiosIns = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    Accept: 'application/json'
  }
});

axiosIns.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosIns.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 503) {
      Alert(
        'Service Unavailable!',
        'Services are unavailable at the moment. Please try again after some time. We appreciate your patience.',
        'error'
      );
    } else if (error.response && error.response.status === 403) {
      Alert('Alert!', `${error.response.data.message}`, 'warning', {
        okText: 'Go to Easebuzz',
        onOk: () => {
          window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}`);
        }
      });
      setTimeout(() => {
        window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}`);
      }, 5000);
    } else if (error.response && error.response.status === 401) {
      const redirectUrl = `${process.env.REACT_APP_AUTH_URL}?next=${process.env.REACT_APP_AUTH_REDIRECT_URL}`;
      const message =
        'Seems like you are not logged in. You will be redirected to Easebuzz Login Page in 5 seconds...';

      Alert('Authentication Failed!', message, 'warning', {
        hideFooter: true
      });

      setTimeout(() => {
        window.location.replace(redirectUrl);
      }, 1000);
    }
    return Promise.reject(error);
  }
);

export default axiosIns;
